var _path, _path2, _polygon, _path3, _polygon2, _path4, _path5, _path6, _path7, _path8, _rect, _path9, _ellipse, _ellipse2, _ellipse3, _path10, _path11, _path12, _path13, _path14, _path15, _circle, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _polygon3, _path28, _polygon4, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _circle2, _path40;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkTogether(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 844.52097,
    height: 544.59508,
    viewBox: "0 0 844.52097 544.59508",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M931.14105,699.03863l13.887.36551a44.822,44.822,0,0,0,6.7571-20.48c-8.89865,9.43551-24.595,7.065-36.08827,13.07507a26.96057,26.96057,0,0,0-13.82546,18.84016l-5.72591,8.01794a45.17742,45.17742,0,0,0,37.19059-6.91016,43.63879,43.63879,0,0,0,8.00025-7.47307C936.18548,702.09145,931.14105,699.03863,931.14105,699.03863Z",
    transform: "translate(-177.73951 -177.70246)",
    fill: "#f2f2f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M923.49136,677.89435l12.5925-5.8662a44.82209,44.82209,0,0,0-3.08581-21.344c-3.75662,12.41382-18.86274,17.29241-26.4693,27.79742a26.96057,26.96057,0,0,0-3.972,23.02864l-1.54908,9.73A45.17742,45.17742,0,0,0,931.213,688.469a43.63836,43.63836,0,0,0,3.82772-10.25668C929.36785,678.377,923.49136,677.89435,923.49136,677.89435Z",
    transform: "translate(-177.73951 -177.70246)",
    fill: "#f2f2f2"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "725.084 533.946 716.566 533.946 712.514 501.092 725.085 501.092 725.084 533.946",
    fill: "#a0616a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M902.59641,708.86507l-9.08836-3.69172-.26812-.11-5.01854,3.80174a10.685,10.685,0,0,0-10.67646,10.22271c-.01377.15122-.01377.30937-.01377.46747v.35062h27.46452v-11.0408Z",
    transform: "translate(-177.73951 -177.70246)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "708.863 516.955 701.522 521.275 681.367 495.014 692.202 488.639 708.863 516.955",
    fill: "#a0616a"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M891.67247,698.9861l-.9968-1.69808-3.60923-6.13224-1.87683,1.10682-.19247.11-9.7071,1.42991-.28877.04129-2.39239,5.82287A10.68981,10.68981,0,0,0,868.814,714.303l.17875.2956,23.66966-13.92815Z",
    transform: "translate(-177.73951 -177.70246)",
    fill: "#2f2e41"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M913.61121,510.79661c3.9935,12.04439,3.5713,25.11823-.9599,39.15l-1.18267,48.23631L907.67,628.60959a52.09865,52.09865,0,0,1,3.46672,18.68115c-.01615,16.74127-1.14179,40.52495-6.84893,51.6977H890.782l-3.04874-49.75469-3.63816-25.01587-.44852-26.80669-.39118-23.37977-14.685,21.47379-14.26985,20.86666,14.18354,23.92474,12.3745,38.49844-13.062,10.99955-14.81769-28.09247-7.18142-8.34355-19.60394-42.43815,1.76178-5.90879a139.78376,139.78376,0,0,1,15.66252-34.53159l0,0,19.49945-45.25659Z",
    transform: "translate(-177.73951 -177.70246)",
    fill: "#2f2e41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M688.66247,519.79661H420.65233a8.07558,8.07558,0,0,1-8.06636-8.06636V306.86267a8.07532,8.07532,0,0,1,8.06636-8.06606H688.66247a8.07532,8.07532,0,0,1,8.06636,8.06606V511.73025A8.07557,8.07557,0,0,1,688.66247,519.79661Z",
    transform: "translate(-177.73951 -177.70246)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M688.66229,520.79661H420.65252a9.077,9.077,0,0,1-9.06641-9.06641V306.86253a9.07653,9.07653,0,0,1,9.06641-9.06592H688.66229a9.07652,9.07652,0,0,1,9.0664,9.06592V511.7302A9.07694,9.07694,0,0,1,688.66229,520.79661Zm-268.00977-221a7.07424,7.07424,0,0,0-7.06641,7.06592V511.7302a7.07434,7.07434,0,0,0,7.06641,7.06641H688.66229a7.07434,7.07434,0,0,0,7.0664-7.06641V306.86253a7.07423,7.07423,0,0,0-7.0664-7.06592Z",
    transform: "translate(-177.73951 -177.70246)",
    fill: "#f0f0f0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M413.205,480.79661V511.7304a7.45828,7.45828,0,0,0,7.44716,7.44716H688.66262a7.45828,7.45828,0,0,0,7.44716-7.44716V480.79661Z",
    transform: "translate(-177.73951 -177.70246)",
    fill: "#f0f0f0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 554.65076,
    y: 224.09029,
    width: 1.99962,
    height: 333.55961,
    transform: "translate(-250.87539 470.37299) rotate(-57.37135)",
    fill: "#f0f0f0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M875.60125,214.25494H243.27789a1.01559,1.01559,0,0,1,0-2.03069H875.60125a1.01559,1.01559,0,0,1,0,2.03069Z",
    transform: "translate(-177.73951 -177.70246)",
    fill: "#cacaca"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 87.89347,
    cy: 11.16881,
    rx: 10.92534,
    ry: 11.16881,
    fill: "#3f3d56"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 125.63554,
    cy: 11.16881,
    rx: 10.92534,
    ry: 11.16881,
    fill: "#3f3d56"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.37762,
    cy: 11.16881,
    rx: 10.92534,
    ry: 11.16881,
    fill: "#3f3d56"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M852.98423,180.47076h-26.81a2.0304,2.0304,0,0,0,0,4.06h26.81a2.0304,2.0304,0,0,0,0-4.06Z",
    transform: "translate(-177.73951 -177.70246)",
    fill: "#3f3d56"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M852.98423,188.09076h-26.81a2.0304,2.0304,0,0,0,0,4.06h26.81a2.0304,2.0304,0,0,0,0-4.06Z",
    transform: "translate(-177.73951 -177.70246)",
    fill: "#3f3d56"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M852.98423,195.70074h-26.81a2.0304,2.0304,0,0,0,0,4.06h26.81a2.0304,2.0304,0,0,0,0-4.06Z",
    transform: "translate(-177.73951 -177.70246)",
    fill: "#3f3d56"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M779.50328,452.98922a6.6176,6.6176,0,0,0,10.13608.47785l21.56551,9.37924-2.1006-12.03868-20.15693-7.061a6.65349,6.65349,0,0,0-9.44406,9.24262Z",
    transform: "translate(-177.73951 -177.70246)",
    fill: "#a0616a"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M799.12472,446.188l41.19723,5.33928,42.485-25.59256a18.78361,18.78361,0,0,1,26.80668,8.35028h0a18.80383,18.80383,0,0,1-8.4331,24.39256l-57.08925,20.34375-.10746.03844L793.89442,456.748Z",
    transform: "translate(-177.73951 -177.70246)",
    fill: "#3f3d56"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M859.28737,518.07907l3.42446-8.561-2.26477-7.36036,6.71034-73.36111h0l.99127-11.11841.06685-8.288,22.946-.55964L893.65,415.1499l4.924,2.9442a35.64637,35.64637,0,0,1,17.30724,31.18056l-.88947,48.12064,2.28984,4.58023a9.63783,9.63783,0,0,1-5.67976,13.49028l-50.44447,15.3308Z",
    transform: "translate(-177.73951 -177.70246)",
    fill: "#3f3d56"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 699.84774,
    cy: 202.42136,
    r: 20.8488,
    fill: "#a0616a"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M899.29724,384.66879c.62184-2.6197.33635-6.30613-.01507-8.94389a25.03482,25.03482,0,0,0-10.59629-17.38372,7.63326,7.63326,0,0,0-3.80218-1.511,3.28226,3.28226,0,0,0-3.3002,1.99619,6.84189,6.84189,0,0,0-3.8598-3.82756,12.05793,12.05793,0,0,0-5.49444-.74021,20.08039,20.08039,0,0,0-16.75192,11.9747c-.55688,1.32291-2.11229-3.56352-2.81785-2.31357a5.55713,5.55713,0,0,1-3.15143,2.76892c-1.38251.38578-1.944,6.08184-2.48811,4.75362a6.33176,6.33176,0,0,0,6.05343,8.82879,34.87045,34.87045,0,0,0,4.143-.793,10.32927,10.32927,0,0,1,11.3093,7.73074,13.68475,13.68475,0,0,1,1.80033-4.00553,4.63181,4.63181,0,0,1,3.71585-2.04166,5.2038,5.2038,0,0,1,3.57592,2.05552c.91784,1.07772,1.6072,2.3351,2.53182,3.407,2.71306,3.14524,6.38255,10.4801,10.24894,9.94514C893.44979,396.14715,898.4482,388.24565,899.29724,384.66879Z",
    transform: "translate(-177.73951 -177.70246)",
    fill: "#2f2e41"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M938.82557,555.89408a6.61765,6.61765,0,0,0-2.83685-9.74274l1.87445-23.442-10.70577,5.89313-.1387,21.35744a6.6535,6.6535,0,0,0,11.80687,5.93417Z",
    transform: "translate(-177.73951 -177.70246)",
    fill: "#a0616a"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M926.02574,539.541l-8.31682-40.70074-37.993-31.88244a18.78361,18.78361,0,0,1-.79944-28.06575h0a18.80382,18.80382,0,0,1,25.80911.06221l37.76678,47.3996.07123.08917-4.85208,54.61886Z",
    transform: "translate(-177.73951 -177.70246)",
    fill: "#3f3d56"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1021.0698,722.29754h-347.988a1.19069,1.19069,0,1,1,0-2.38137h347.988a1.19069,1.19069,0,1,1,0,2.38137Z",
    transform: "translate(-177.73951 -177.70246)",
    fill: "#ccc"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M796.17743,528.6544H638.03771a4.16145,4.16145,0,0,1-4.15662-4.15662V460.33154a4.16146,4.16146,0,0,1,4.15662-4.15663H796.17743a4.16139,4.16139,0,0,1,4.15662,4.15663v64.16624A4.16138,4.16138,0,0,1,796.17743,528.6544Z",
    transform: "translate(-177.73951 -177.70246)",
    fill: "#2a78ff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M781.11961,559.43533h-128.024a4.98795,4.98795,0,1,1,0-9.97589h128.024C787.55215,549.36965,787.61649,559.52593,781.11961,559.43533Z",
    transform: "translate(-177.73951 -177.70246)",
    fill: "#e4e4e4"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M781.11961,582.29676h-128.024a4.98795,4.98795,0,0,1,0-9.9759h128.024C787.55215,572.23107,787.61649,582.38736,781.11961,582.29676Z",
    transform: "translate(-177.73951 -177.70246)",
    fill: "#e4e4e4"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M781.11961,605.15818h-128.024a4.98795,4.98795,0,1,1,0-9.97589h128.024C787.55215,595.0925,787.61649,605.24878,781.11961,605.15818Z",
    transform: "translate(-177.73951 -177.70246)",
    fill: "#e4e4e4"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M386.63821,642.09329l13.24162-4.20034a44.8221,44.8221,0,0,0-.319-21.56359c-5.31984,11.82854-20.92743,14.72661-29.82018,24.1677a26.96059,26.96059,0,0,0-6.89675,22.32778l-2.7859,9.45051a45.17739,45.17739,0,0,0,32.87975-18.70324,43.63869,43.63869,0,0,0,5.11331-9.68013C392.404,643.32671,386.63821,642.09329,386.63821,642.09329Z",
    transform: "translate(-177.73951 -177.70246)",
    fill: "#f2f2f2"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M372.4887,624.6179l9.97854-9.665a44.82209,44.82209,0,0,0-9.90246-19.15807c.51382,12.9596-12.16315,22.51418-15.912,34.93035a26.96056,26.96056,0,0,0,3.78488,23.06013l1.72124,9.70107a45.17744,45.17744,0,0,0,21.08749-31.40394,43.639,43.639,0,0,0,.25947-10.94457C378.19944,623.15042,372.4887,624.6179,372.4887,624.6179Z",
    transform: "translate(-177.73951 -177.70246)",
    fill: "#f2f2f2"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M399.1658,444.66928a7.52289,7.52289,0,0,1-8.51517-7.78187l-48.09647-48.80072,13.42658-9.34746L399.03607,429.648a7.56363,7.56363,0,0,1,.12973,15.02128Z",
    transform: "translate(-177.73951 -177.70246)",
    fill: "#ffb6b6"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M327.75776,366.97811s-3.40875,2.04312,2.26484,8.26467c4.54215,4.98081,24.36293,28.92837,32.27447,33.9282-.86281,2.49126,21.02175,26.34234,23.32251,27.863l12.164-15.17955c-.6949-4.35213-24.62925-25.12984-26.27763-24.60133l-7.6317-9.48634-17.29159-29.00363-16.38708,6.69437Z",
    transform: "translate(-177.73951 -177.70246)",
    fill: "#2a78ff"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "112.035 480.052 121.102 480.052 125.417 445.078 112.034 445.078 112.035 480.052",
    fill: "#ffb6b6"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M286.81481,651.544l14.48631-.86463v6.20656l13.77254,9.51181a3.87685,3.87685,0,0,1-2.203,7.06714l-17.24649,0-2.9727-6.13925-1.16069,6.13925h-6.50261Z",
    transform: "translate(-177.73951 -177.70246)",
    fill: "#2f2e41"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "162.968 480.052 172.035 480.052 176.35 445.078 162.968 445.078 162.968 480.052",
    fill: "#ffb6b6"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M337.74786,651.544l14.48631-.86463v6.20656l13.77254,9.51181a3.87685,3.87685,0,0,1-2.203,7.06714l-17.24649,0-2.9727-6.13925-1.16069,6.13925h-6.50261Z",
    transform: "translate(-177.73951 -177.70246)",
    fill: "#2f2e41"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M285.86178,627.59413h.09858l1.74384-56.867a14.87005,14.87005,0,0,1,.19511-14.05194l.24966-.45193-.64734-3.00072a19.11352,19.11352,0,0,1,1.09226-11.50324l1.62684-53.04638c-5.812-37.66677,21.88634-62.23162,21.88634-62.23162l-5.06161-21.29269,50.11155-4.929-3.5574,26.22169,8.908,30.60567c5.88895,57.374,4.8204,113.28328-4.52452,167.44994l.25476.12883c.91734.31665,1.31077,1.58741.879,2.83844s-1.52548,2.00849-2.44281,1.69184l-21.91283-.76217c-.91733-.31657-1.31091-1.58741-.879-2.83844.43175-1.251,1.52548-2.00842,2.44281-1.69184l1.48994.75359-3.17752-54.87452.35263-10.02317-.72647-11.3711-3.35883-51.14711-12.71368,62.89653-12.98639,68.1293a2.38889,2.38889,0,0,1-1.61089,4.15967h-17.732a2.39631,2.39631,0,0,1,0-4.79261Z",
    transform: "translate(-177.73951 -177.70246)",
    fill: "#2f2e41"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M347.397,351.582l-9.85494-5.913-19.70988-1.971-17.42074,8.871.1746,27.09955,11.05157,28.10695,43.05489,8.87405,5.02317-24.70113s12.81142-17.20734-.98549-27.06228Z",
    transform: "translate(-177.73951 -177.70246)",
    fill: "#2a78ff"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M305.21219,468.58869a7.52287,7.52287,0,0,1-1.6681-11.41416l-6.3551-68.22312,16.31137,1.25981,1.11782,66.66495a7.56363,7.56363,0,0,1-9.406,11.71252Z",
    transform: "translate(-177.73951 -177.70246)",
    fill: "#ffb6b6"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M301.01556,352.84092s-3.93229-.57536-3.47683,7.83236c.36464,6.731-1.36843,48.21939,1.593,57.09749-2.24467,1.38285-2.36413,35.15015-1.54511,37.78361l19.0247-4.05483c2.21628-3.80947.75711-38.72087-.85365-39.35487l.09462-12.17475,4.20458-40.13088-16.19145-6.63269Z",
    transform: "translate(-177.73951 -177.70246)",
    fill: "#2a78ff"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M398.24783,474.90117a5.41136,5.41136,0,0,1-1.11673-4.51063,72.0123,72.0123,0,0,0,0-28.37347,5.41137,5.41137,0,0,1,1.11673-4.51063,5.28944,5.28944,0,0,1,4.02487-1.941c8.288-3.30285,16.22505-3.30325,23.59529.0004a5.35173,5.35173,0,0,1,5.20457,4.59929,119.10339,119.10339,0,0,1,0,32.07744,5.35142,5.35142,0,0,1-5.29442,4.60008H402.35333A5.28843,5.28843,0,0,1,398.24783,474.90117Z",
    transform: "translate(-177.73951 -177.70246)",
    fill: "#2a78ff"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M404.8066,447.79526h19.716a1.23226,1.23226,0,0,0,0-2.46451h-19.716a1.23225,1.23225,0,0,0,0,2.46451Z",
    transform: "translate(-177.73951 -177.70246)",
    fill: "#fff"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M404.8066,457.65327h19.716a1.23226,1.23226,0,0,0,0-2.46451h-19.716a1.23226,1.23226,0,0,0,0,2.46451Z",
    transform: "translate(-177.73951 -177.70246)",
    fill: "#fff"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M404.8066,467.51127h19.716a1.23225,1.23225,0,0,0,0-2.4645h-19.716a1.23225,1.23225,0,0,0,0,2.4645Z",
    transform: "translate(-177.73951 -177.70246)",
    fill: "#fff"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M460.40956,673.10754a1.18647,1.18647,0,0,1-1.19007,1.19h-280.29a1.19,1.19,0,1,1,0-2.38h280.29A1.18651,1.18651,0,0,1,460.40956,673.10754Z",
    transform: "translate(-177.73951 -177.70246)",
    fill: "#ccc"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "a0ad7a78-ce9c-4e5a-964d-79d0781968c2-195",
    "data-name": "a1ca5f83-7fa1-45b1-9d3b-bf096f25c0e5",
    d: "M346.15958,333.62371V315.26234a24.60388,24.60388,0,1,0-49.20774-.0316v.0316c-4.33641,9.03639-1.62353,13.33257,0,18.36137a3.309,3.309,0,0,0,3.30352,3.30352h42.59906A3.30907,3.30907,0,0,0,346.15958,333.62371Z",
    transform: "translate(-177.73951 -177.70246)",
    fill: "#2f2e41"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 151.88324,
    cy: 139.61473,
    r: 18.41689,
    fill: "#ffb7b7"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M310.34868,322.1453c.16692-.02638.33385-.06155.50077-.08794,2.87277-.5095,5.74549-1.01021,8.60947-1.52861l.26359-6.49216,3.47011,5.81568c7.91546,2.62677,15.32136,1.14212,22.288-2.13474a62.923,62.923,0,0,0,6.67677-3.68094,24.40688,24.40688,0,0,0-11.9918-17.2717c-.26354-.14939-.51829-.28108-.78189-.413a.00859.00859,0,0,1-.00874-.00879c-.44805-.21083-.9049-.41288-1.36175-.59733a20.28683,20.28683,0,0,0-21.29528,4.129C311.09546,305.24261,308.56532,314.10684,310.34868,322.1453Z",
    transform: "translate(-177.73951 -177.70246)",
    fill: "#2f2e41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkTogether);
export default __webpack_public_path__ + "static/media/work_together.5c2ade144109e2d70dff3961bf5491e7.svg";
export { ForwardRef as ReactComponent };